import {createTheme} from "@mui/material";

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // prevent uppercase text
          backgroundColor: 'rgb(59, 68, 100)',
          variant: 'contained',
          fontFamily: `Monaco,sans-serif`,
          fontSize: '14px',
          size: 'small'
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: 'green', // set anchor link color to green
        },
      },
    },
  },
  palette: {
    main: {
      primary: "#b7b7b7",
    },
    mode: 'dark',
    background: {
      default: "#171717"
    },
    text:{
      primary: "#b7b7b7"
    }
  },
});

theme.typography.h2 = {
  color: `#b7b7b7`,
  marginBottom: `8px`,
};


theme.typography.h5 = {
  color: `#b7b7b7`,
  fontSize: '0.8rem',
  '@media (min-width:600px)': {
    fontSize: '1.0rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.2rem',
  },
};

theme.typography.h6 = {
  color: `#b7b7b7`,
  fontSize: '0.6rem',
  '@media (min-width:600px)': {
    fontSize: '7.5rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.2rem',
  },
};

theme.typography.h1 = {
  color: `#b7b7b7`,
  fontSize: '1.8rem',
};

export default theme;
